import { motion } from 'framer-motion';
import { ArrowRight, FileCheck2, Loader2 } from 'lucide-react';
import { Button } from '../ui/button';
import { Card, CardContent } from '../ui/card';
import { RuleResults } from './RuleResults';

export const ScenarioResultCard = ({ evaluation, isLast, onContinue, loading }) => (
    <motion.div initial={{ opacity: 0, y: 12 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.3 }}>
        <Card className="border-sky-200 dark:border-sky-800" data-testid="eeoc-scenario-result">
            <CardContent className="space-y-5 p-6">
                <div className="flex flex-wrap items-center justify-between gap-4">
                    <div>
                        <p className="text-xs font-semibold uppercase tracking-wide text-sky-600">Scenario evaluation</p>
                        <p className="mt-1 text-sm text-muted-foreground">
                            {evaluation.rules_passed} of {evaluation.rules_total} EEOC rules passed
                        </p>
                    </div>
                    <div className="text-right">
                        <p className="text-4xl font-bold tabular-nums" data-testid="eeoc-scenario-score">{evaluation.score}</p>
                        <p className="text-xs text-muted-foreground">scenario compliance score</p>
                    </div>
                </div>
                <RuleResults rules={evaluation.rules} testPrefix="eeoc-rule" />
                {evaluation.summary && <p className="text-sm text-muted-foreground">{evaluation.summary}</p>}
                <p className="text-xs text-muted-foreground">Detailed coaching and practice drills are in your session report.</p>
                <div className="flex justify-end">
                    <Button onClick={onContinue} disabled={loading} className="bg-sky-600 hover:bg-sky-700" data-testid="eeoc-continue-btn">
                        {loading ? <Loader2 className="mr-2 h-4 w-4 animate-spin" /> : isLast ? <FileCheck2 className="mr-2 h-4 w-4" /> : <ArrowRight className="mr-2 h-4 w-4" />}
                        {isLast ? 'View session report' : 'Next scenario'}
                    </Button>
                </div>
            </CardContent>
        </Card>
    </motion.div>
);
